import { Link } from 'react-router'
import { Fragment } from 'react/jsx-runtime'

import SlashIcon from 'assets/icons/slash.svg'

import { combineClassnames } from 'app/common/presentation'

import styles from './Breadcrumb.module.scss'

export interface BreadcrumbPath {
  name: string
  path?: string
}

export interface BreadcrumbProps {
  className?: string
  paths: BreadcrumbPath[]
}

const Breadcrumb = ({ className, paths }: BreadcrumbProps) => (
  <div className={combineClassnames(styles.breadcrumb, className)} data-testid="breadcrumb">
    {paths.map((path, index) => (
      <Fragment key={path.name}>
        {index > 0 && <SlashIcon className={styles.separator} />}

        {path.path ? <Link to={path.path}>{path.name}</Link> : <span>{path.name}</span>}
      </Fragment>
    ))}
  </div>
)

export default Breadcrumb
